import axios from 'axios'

import { getApiUrl } from '../../util/api/api'

const uploadLogo = (formData: FormData) => axios
  .post<{location: string}>(getApiUrl('/api/v1/image'), formData, { withCredentials: true })

export default uploadLogo
